import { Observable } from 'rxjs/Observable';
import { getSourceForInstance } from './effects_metadata';
import { EffectNotification } from './effect_notification';

export interface OnRunEffects {
  ngrxOnRunEffects(
    resolvedEffects$: Observable<EffectNotification>
  ): Observable<EffectNotification>;
}

const /** @type {?} */ onRunEffectsKey: keyof OnRunEffects = 'ngrxOnRunEffects';
/**
 * @param {?} sourceInstance
 * @return {?}
 */
export function isOnRunEffects(
  sourceInstance: Object
): sourceInstance is OnRunEffects {
  const /** @type {?} */ source = getSourceForInstance(sourceInstance);

  return (
    onRunEffectsKey in source && typeof source[onRunEffectsKey] === 'function'
  );
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/on_run_effects.ts